import React from "react";
import { StateDispatchProps } from "../components/state-dispatch.props";
import { Box } from "@mui/material";
import StarsIcon from "@mui/icons-material/Stars";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useStyles } from "../utils/styles.hook";
import { QqResControlFactory } from "./qq-res-control.factory";
import { ResGroupTitleTypography } from "./qq-typohraphy.controls";

export type QqResultBoxProps = StateDispatchProps & {
  result: string;
  isRecommendation: boolean;
};

export const QqResultBoxControl: React.FunctionComponent<QqResultBoxProps> = ({
  result,
  isRecommendation,
  state,
  dispatch,
}) => {
  const classes = useStyles();
  const resultDataControlFactory = new QqResControlFactory();

  return (
    <Box
      sx={{
        border: "1px solid rgba(224, 224, 224, 1)",
        borderRadius: "8px",
        marginTop: "10px",
        marginBottom: "10px",
        padding: "10px",
      }}
    >
      <Box>
        {isRecommendation ? (
          <ResGroupTitleTypography className={classes.wrapIcon}>
            <StarsIcon fontSize="small" sx={{ color: "orange" }} />
            &nbsp;&nbsp;Top recommendation
          </ResGroupTitleTypography>
        ) : (
          <ResGroupTitleTypography className={classes.wrapIcon}>
            <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green" }} />
            &nbsp;&nbsp;Also good
          </ResGroupTitleTypography>
        )}
      </Box>
      <Box sx={{ marginTop: "10px" }}>
        {resultDataControlFactory.create(result, { state, dispatch })}
      </Box>
    </Box>
  );
};
